import React from 'react';
import './TractInfoPanel.css';

const TractInfoPanel = ({ tract, onClose, overlays }) => {
  console.log('Tract');
  console.log(JSON.stringify(tract, null, 2));

  if (!tract) return null;

  const formatCurrency = (value) => {
    if (value === null || value === undefined || value === 0) return 'N/A';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0
    }).format(value);
  };

  const formatNumber = (value) => {
    if (value === null || value === undefined) return 'N/A';
    return new Intl.NumberFormat('en-US').format(value);
  };

  const formatPercent = (value, digits = 1) => {
    if (value === null || value === undefined) return 'N/A';
    return `${Number(value).toFixed(digits)}%`;
  };

  const evictionRateColor = (rate) => {
    if (rate === null || rate === undefined) return undefined;
    if (rate > 4) return '#dc2626';
    if (rate > 2) return '#f59e0b';
    return '#10b981';
  };

const incomePct = tract.incomePercent;

const safeIncome = Number(incomePct);

// incomeCategory
const incomeCategory =
  !safeIncome || isNaN(safeIncome) || safeIncome <= 0 ? 'Unknown' :
  safeIncome < 50 ? 'Low' :
  safeIncome < 80 ? 'Moderate' :
  safeIncome < 120 ? 'Middle' :
  'Upper';

// incomeColor
const incomeColor =
  !safeIncome || isNaN(safeIncome) || safeIncome <= 0 ? '#9CA3AF' :
  safeIncome < 50 ? '#DC2626' :
  safeIncome < 80 ? '#F97316' :
  safeIncome < 120 ? '#A3E635' :
  '#16A34A';


  const hasEvictionData =
    tract.evictionFilingRate !== null && tract.evictionFilingRate !== undefined ||
    tract.evictionFilings ||
    tract.evictionThreatened ||
    tract.evictionJudgements ||
    tract.evictionYear;

  return (
    <div className="tract-info-panel">
      <div className="tract-info-header">
        <h3>Census Tract {tract.tractCode || 'N/A'}</h3>
        <button className="tract-info-close" onClick={onClose}>×</button>
      </div>

      <div className="tract-info-content">
        {/* Income */}
        {overlays?.income && (
          <div className="tract-info-section">
            <h4>Income Data</h4>
            <div className="tract-info-row">
              <span className="tract-info-label">Tract Median Income:</span>
              <span className="tract-info-value">
                {formatCurrency(tract.medianIncome)}
              </span>
            </div>
            <div className="tract-info-row">
              <span className="tract-info-label">MSA Median Income:</span>
              <span className="tract-info-value">
                {formatCurrency(tract.msaMedianIncome)}
              </span>
            </div>
            <div className="tract-info-row">
              <span className="tract-info-label">Income % of MSA:</span>
              <span className="tract-info-value">
                {formatPercent(tract.incomePercent)}
              </span>
            </div>
            <div className="tract-info-row">
            <span className="tract-info-label">Income Category:</span>
            <span
              className="tract-info-value"
              style={{ color: incomeColor, fontWeight: 600 }}
            >
              {incomeCategory}
            </span>
          </div>  
        </div>
        )}

        {/* Evictions right under income */}
        {overlays?.eviction && hasEvictionData && (
          <div className="tract-info-section">
            <h4>Eviction Data</h4>

            {tract.evictionFilingRate !== null && tract.evictionFilingRate !== undefined && (
              <div className="tract-info-row">
                <span className="tract-info-label">Eviction Filing Rate:</span>
                <span
                  className="tract-info-value"
                  style={{
                    color: evictionRateColor(tract.evictionFilingRate),
                    fontWeight: 600
                  }}
                >
                  {formatPercent(tract.evictionFilingRate, 2)}
                </span>
              </div>
            )}

            {tract.evictionFilings > 0 && (
              <div className="tract-info-row">
                <span className="tract-info-label">Eviction Filings:</span>
                <span className="tract-info-value">
                  {formatNumber(tract.evictionFilings)}
                </span>
              </div>
            )}

            {tract.evictionThreatened > 0 && (
              <div className="tract-info-row">
                <span className="tract-info-label">Threatened Evictions:</span>
                <span className="tract-info-value">
                  {formatNumber(tract.evictionThreatened)}
                  {tract.evictionThreatenedRate !== null &&
                    tract.evictionThreatenedRate !== undefined &&
                    ` (${formatPercent(tract.evictionThreatenedRate)})`}
                </span>
              </div>
            )}

            {tract.evictionJudgements > 0 && (
              <div className="tract-info-row">
                <span className="tract-info-label">Eviction Judgements:</span>
                <span className="tract-info-value">
                  {formatNumber(tract.evictionJudgements)}
                  {tract.evictionJudgementRate !== null &&
                    tract.evictionJudgementRate !== undefined &&
                    ` (${formatPercent(tract.evictionJudgementRate)})`}
                </span>
              </div>
            )}

            {tract.evictionYear && (
              <div className="tract-info-row">
                <span className="tract-info-label">Data Year:</span>
                <span className="tract-info-value">{tract.evictionYear}</span>
              </div>
            )}
          </div>
        )}

        {/* Demographics */}
        {overlays?.demographics && (
          <div className="tract-info-section">
            <h4>Demographics</h4>
            <div className="tract-info-row">
              <span className="tract-info-label">Population:</span>
              <span className="tract-info-value">
                {formatNumber(tract.population)}
              </span>
            </div>
            <div className="tract-info-row">
              <span className="tract-info-label">Median Age:</span>
              <span className="tract-info-value">
                {tract.medianAge ? `${tract.medianAge} years` : 'N/A'}
              </span>
            </div>
            <div className="tract-info-row">
              <span className="tract-info-label">Minority %:</span>
              <span className="tract-info-value">
                {formatPercent(tract.minorityPercent)}
              </span>
            </div>
          </div>
        )}

        {/* Housing */}
        <div className="tract-info-section">
          <h4>Housing</h4>
          <div className="tract-info-row">
            <span className="tract-info-label">Median Rent:</span>
            <span className="tract-info-value">
              {formatCurrency(tract.medianRent)}
            </span>
          </div>
          <div className="tract-info-row">
            <span className="tract-info-label">Median Home Value:</span>
            <span className="tract-info-value">
              {formatCurrency(tract.medianHomeValue)}
            </span>
          </div>
        </div>

        {/* HUD LMI Data */}
        {tract.lmiPercent !== undefined && (
          <div className="tract-info-section">
            <h4>Low-to-Moderate Income</h4>
            <div className="tract-info-row">
              <span className="tract-info-label">LMI Population:</span>
              <span className="tract-info-value">
                {formatNumber(tract.lmiPopulation)}
              </span>
            </div>
            <div className="tract-info-row">
              <span className="tract-info-label">LMI %:</span>
              <span className="tract-info-value">
                {formatPercent(tract.lmiPercent)}
              </span>
            </div>
          </div>
        )}

        {/* GEOID */}
        {tract.geoid && (
          <div className="tract-info-footer">
            <small>GEOID: {tract.geoid}</small>
          </div>
        )}
      </div>
    </div>
  );
};

export default TractInfoPanel;
